// TenantNamespace — first enforcement layer of cross-tenant isolation
// (Master Rule 1.4 → CLAUDE.md #4). 'layer1' is the global certified-template
// namespace; 'studio-*' is per-tenant. Vector queries cannot cross either.
import { z } from "zod";
const STUDIO_PREFIX = "studio-";
export const TenantNamespaceSchema = z
    .string()
    .min(1)
    .refine((v) => v === "layer1" ||
    (v.startsWith(STUDIO_PREFIX) && v.length > STUDIO_PREFIX.length), { message: 'TenantNamespace must be "layer1" or "studio-<id>"' });
export function isTenantNamespace(value) {
    if (typeof value !== "string")
        return false;
    if (value === "layer1")
        return true;
    return value.startsWith(STUDIO_PREFIX) && value.length > STUDIO_PREFIX.length;
}
/**
 * Map a tenant namespace to the tenant-id form used as a tenant/Firestore key:
 * "studio-x" -> "tenant-x". Any non-"studio-" string (including "layer1") is
 * returned unchanged. Accepts a plain string since some callers hold the
 * namespace untyped; single source for the previously-inlined
 * `ns.replace(/^studio-/, "tenant-")`.
 */
export function namespaceToTenantId(ns) {
    return ns.replace(/^studio-/, "tenant-");
}
/**
 * Map a tenant namespace to its Postgres schema name for the [S-617]
 * measures store (schema-per-tenant): "studio-pinnacle-pictures" ->
 * "studio_pinnacle_pictures". A separate mapping from namespaceToTenantId
 * (which keeps hyphens) — Postgres unquoted identifiers can't contain them.
 */
export function namespaceToSchemaName(ns) {
    return ns.replace(/-/g, "_");
}
//# sourceMappingURL=TenantNamespace.js.map